import React from 'react';
import { Search, Trash2 } from 'lucide-react';
import { TemplateCategory } from './types';

interface TemplateFilterProps {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    categories: TemplateCategory[];
    selectedCategory: string;
    setSelectedCategory: (value: string) => void;
    getCategoryCount: (categoryId: string) => number;
    showDeleteConfirmation: (id: string, name: string) => void;
}

const TemplateFilter: React.FC<TemplateFilterProps> = ({
    searchTerm,
    setSearchTerm,
    categories,
    selectedCategory,
    setSelectedCategory,
    getCategoryCount,
    showDeleteConfirmation,
}) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="p-6 space-y-4">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Şablon ara..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <div className="flex flex-wrap gap-2">
                    <button
                        onClick={() => setSelectedCategory('all')}
                        className={`flex items-center px-3 py-2 rounded-lg text-sm transition-colors ${selectedCategory === 'all'
                                ? 'bg-blue-100 text-blue-800 border-blue-200'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            } border`}
                    >
                        Tümü
                        <span className="ml-2 bg-white text-gray-600 px-2 py-0.5 rounded-full text-xs">
                            {getCategoryCount('all')}
                        </span>
                    </button>

                    {getCategoryCount('uncategorized') > 0 && (
                        <button
                            onClick={() => setSelectedCategory('uncategorized')}
                            className={`flex items-center px-3 py-2 rounded-lg text-sm transition-colors ${selectedCategory === 'uncategorized'
                                    ? 'bg-gray-100 text-gray-800 border-gray-200'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                } border`}
                        >
                            Kategorisiz
                            <span className="ml-2 bg-white text-gray-600 px-2 py-0.5 rounded-full text-xs">
                                {getCategoryCount('uncategorized')}
                            </span>
                        </button>
                    )}

                    {categories.map((category) => (
                        <div key={category.id} className="flex items-center group">
                            <button
                                onClick={() => setSelectedCategory(category.id)}
                                className={`flex items-center px-3 py-2 rounded-l-lg text-sm transition-colors ${selectedCategory === category.id
                                        ? 'text-white border-2 border-r-0'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-r-0'
                                    }`}
                                style={{
                                    backgroundColor:
                                        selectedCategory === category.id ? category.color : undefined,
                                    borderColor:
                                        selectedCategory === category.id ? category.color : undefined,
                                }}
                            >
                                {category.name}
                                <span className="ml-2 bg-white text-gray-600 px-2 py-0.5 rounded-full text-xs">
                                    {getCategoryCount(category.id)}
                                </span>
                            </button>
                            <button
                                onClick={() => showDeleteConfirmation(category.id, category.name)}
                                className={`px-2 py-2 rounded-r-lg text-sm transition-colors ${selectedCategory === category.id
                                        ? 'text-white border-2 border-l-0 hover:bg-red-600'
                                        : 'bg-gray-100 text-gray-700 hover:bg-red-100 hover:text-red-600 border border-l-0'
                                    }`}
                                style={{
                                    backgroundColor:
                                        selectedCategory === category.id ? category.color : undefined,
                                    borderColor:
                                        selectedCategory === category.id ? category.color : undefined,
                                }}
                                title={`${category.name} kategorisini sil`}
                            >
                                <Trash2 className="h-3 w-3" />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TemplateFilter;
